import { Platform } from 'react-native';

export const MIN_COMPOSER_HEIGHT = Platform.select({
  ios: 40,
  android: 40,
  web: 40,
});
export const MAX_COMPOSER_HEIGHT = 200;
export const DATE_FORMAT = 'll';
export const TIME_FORMAT = 'LT';
